import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import styles from './ViewFriends.module.scss';
import ModalBase from '../ModalBase/ModalBase';
import { BaseModalProps } from '../ModalBase/ModalBase';
import { showQuickView } from '../../../util/modalFlows';

interface PersonProps {
  self: any;
  person: any;
  router: any;
}

const Person: React.FC<PersonProps> = ({ self, person, router }) => (
  <div
    className={styles.person}
    onClick={() => {
      showQuickView(person._id, self._id, router);
    }}
  >
    <div className="pic">
      {(person.photo && typeof person.photo === 'object' && person.photo.url) || person.photoUrl ? (
        <img src={(person.photo && typeof person.photo === 'object' && person.photo.url) || person.photoUrl} alt="" />
      ) : (
        <i className="fas fa-user-alt" />
      )}
    </div>
    <div className={styles.guestInfo}>
      <div className="name">
        {person.name || `${person.firstName} ${person.lastName}`}
      </div>
    </div>
  </div>
);

interface ViewFriendsProps {
  self: any;
  friends: any[];
  router: any;
  baseModalProps: BaseModalProps;
}

const ViewFriends: React.FC<ViewFriendsProps> = ({ self, friends, router, baseModalProps }) => (
  <ModalBase
    baseModalProps={baseModalProps}
    back_img="Back"
    contentClassName="basic"
  >
    <div className={styles.wrapper}>
      <h2 className="modalTitle">Friends List</h2>
      {friends.map((friend) => (
        <Person key={friend._id} self={self} person={friend} router={router} />
      ))}
    </div>
  </ModalBase>
);

const mapStateToProps = (state: any) => ({
  self: state.user.user
});

export default withRouter(connect(mapStateToProps, null)(ViewFriends as any));
